import { NAP } from "@/lib/nap";

const ORG_ID = `${NAP.siteUrl}/#organization`;
const LOGO_URL = `${NAP.siteUrl}/img/logo.svg`;
const OG_IMAGE = `${NAP.siteUrl}/img/og/siddhivinayak-group-og.jpg`;

const organization = {
  "@type": ["Organization", "RealEstateAgent"],
  "@id": ORG_ID,
  name: NAP.brand,
  alternateName: NAP.legalName,
  url: NAP.siteUrl,
  logo: LOGO_URL,
  telephone: NAP.phone,
  email: NAP.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.streetAddress,
    addressLocality: NAP.addressLocality,
    addressRegion: NAP.addressRegion,
    postalCode: NAP.postalCode,
    addressCountry: NAP.addressCountry,
  },
};

/**
 * Build a CollectionPage schema for taxonomy pages (/category/[slug],
 * /tag/[slug]). The same @graph shape works for both — only the
 * displayName + path + breadcrumb differ.
 */
export function buildTaxonomySchema({ kind, slug, displayName, description }) {
  const pageId = `${NAP.siteUrl}/${kind}/${slug}#${kind}page`;
  const pageType = kind === "category" ? "CategoryPage" : "TaggedContent";

  const collection = {
    "@type": pageType,
    "@id": pageId,
    url: `${NAP.siteUrl}/${kind}/${slug}`,
    name: `${displayName} — Blog Posts`,
    description,
    inLanguage: "en-IN",
    isPartOf: { "@id": `${NAP.siteUrl}/#website` },
    about: { "@id": ORG_ID },
    primaryImageOfPage: { "@type": "ImageObject", url: OG_IMAGE },
  };

  const breadcrumb = {
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: NAP.siteUrl },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: `${NAP.siteUrl}/blog`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: displayName,
        item: `${NAP.siteUrl}/${kind}/${slug}`,
      },
    ],
  };

  return {
    "@context": "https://schema.org",
    "@graph": [organization, collection, breadcrumb],
  };
}